import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { AdminGuard } from '../components/auth/AdminGuard';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/admin-login/page'));
const AuthCallbackPage = lazy(() => import('../pages/auth-callback/page'));
const KombinPage = lazy(() => import('../pages/kombin/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const BrandsPage = lazy(() => import('../pages/brands/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog-detail/page'));
const StilTestiPage = lazy(() => import('../pages/stil-testi/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />
  },
  {
    path: '/iletisim',
    element: <ContactPage />
  },
  {
    path: '/yardim',
    element: <HelpPage />
  },
  {
    path: '/gizlilik',
    element: <PrivacyPage />
  },
  {
    path: '/kullanim-kosullari',
    element: <TermsPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/signup',
    element: <SignupPage />
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/settings',
    element: <SettingsPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/admin',
    element: <AdminGuard><AdminPage /></AdminGuard>
  },
  {
    path: '/admin-login',
    element: <AdminLoginPage />
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />
  },
  {
    path: '/kombin/:slug',
    element: <KombinPage />
  },
  {
    path: '/category/:slug',
    element: <CategoryPage />
  },
  {
    path: '/kategori/:slug',
    element: <CategoryPage />
  },
  {
    path: '/markalar',
    element: <BrandsPage />
  },
  {
    path: '/urunler',
    element: <ProductsPage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />
  },
  {
    path: '/stil-testi',
    element: <StilTestiPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;